/* ===========================================================================
   Fiche produit : galerie, pointures, lot deux paires, ajout au panier.

   Les montants sont calculés en centimes entiers. La moitié de 24,99 € vaut
   12,495 € : si la page arrondissait en euros et Shopify en centimes, le
   total affiché et le total facturé divergeraient d'un centime. Tout passe
   donc par Math.round sur des entiers, exactement comme le fait Liquid.
   =========================================================================== */

(function () {
  "use strict";

  var pdp = document.querySelector("[data-al-pdp]");
  if (!pdp) return;

  var $ = function (sel, racine) { return (racine || document).querySelector(sel); };
  var $$ = function (sel, racine) {
    return Array.prototype.slice.call((racine || document).querySelectorAll(sel));
  };

  /* ------------------------------------------------------------ argent --- */

  var FORMAT = window.alMoneyFormat || "{{amount}}";

  function argent(centimes) {
    var valeur = (centimes / 100).toFixed(2);
    var entier = valeur.split(".")[0];
    var decimales = valeur.split(".")[1];

    /* On reproduit les quatre jetons de Shopify plutôt que de deviner. */
    return FORMAT
      .replace(/\{\{\s*amount\s*\}\}/g, grouper(entier, ",") + "." + decimales)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouper(entier, ","))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, grouper(entier, ".") + "," + decimales)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grouper(entier, "."));
  }

  function grouper(entier, separateur) {
    return entier.replace(/\B(?=(\d{3})+(?!\d))/g, separateur);
  }

  /* ----------------------------------------------------------- galerie --- */

  function initGalerie() {
    var rail = $("[data-al-rail]", pdp);
    if (!rail) return;

    var slides = $$("[data-al-slide]", rail);
    var jauge = $("[data-al-progress]", pdp);
    var prec = $("[data-al-prec]", pdp);
    var suiv = $("[data-al-suiv]", pdp);

    function courant() {
      if (!slides.length) return 0;
      return Math.round(rail.scrollLeft / rail.clientWidth);
    }

    function maj() {
      var i = courant();
      if (jauge) jauge.style.width = ((i + 1) / slides.length * 100) + "%";
      if (prec) prec.disabled = i <= 0;
      if (suiv) suiv.disabled = i >= slides.length - 1;
    }

    function aller(i) {
      rail.scrollTo({ left: i * rail.clientWidth, behavior: "smooth" });
    }

    rail.addEventListener("scroll", maj, { passive: true });
    window.addEventListener("resize", maj);
    if (prec) prec.addEventListener("click", function () { aller(courant() - 1); });
    if (suiv) suiv.addEventListener("click", function () { aller(courant() + 1); });
    maj();
  }

  /* ---------------------------------------------------------- pointure --- */

  var champId = $("[data-al-id]", pdp);
  var bouton = $("[data-al-ajouter]", pdp);
  var boutonTexte = $("[data-al-ajouter-texte]", pdp);
  var prixAffiche = $("[data-al-prix]", pdp);

  function varianteChoisie() {
    return $("input[data-al-variante]:checked", pdp);
  }

  function prixUnite() {
    var radio = varianteChoisie();
    return radio ? Number(radio.getAttribute("data-al-prix-variante")) : 0;
  }

  function barreUnite() {
    var radio = varianteChoisie();
    return radio ? Number(radio.getAttribute("data-al-barre-variante")) || 0 : 0;
  }

  function initPointures() {
    $$("input[data-al-variante]", pdp).forEach(function (radio) {
      radio.addEventListener("change", function () {
        $$(".product__swatch--button", pdp).forEach(function (l) { l.classList.remove("is-active"); });
        var etiquette = pdp.querySelector('label[for="' + radio.id + '"]');
        if (etiquette) etiquette.classList.add("is-active");

        if (champId) champId.value = radio.getAttribute("data-al-variante");
        if (prixAffiche) prixAffiche.textContent = argent(prixUnite());

        var epuise = radio.hasAttribute("data-epuise");
        if (bouton) bouton.disabled = epuise;
        if (boutonTexte) boutonTexte.textContent = epuise ? "Sold out" : "Add to cart";

        majLot();
      });
    });
  }

  /* --------------------------------------------------------------- lot --- */

  var lot = $("[data-al-lot]", pdp);
  var lotOff = Number(pdp.getAttribute("data-lot-off")) || 0;
  var lotPalier = 1;

  function prixSeconde() {
    var modele = modeleChoisi();
    var base = modele ? baseSeconde(modele, "prix") : prixUnite();
    return Math.round(base * (100 - lotOff) / 100);
  }

  function barreSeconde() {
    var modele = modeleChoisi();
    return modele ? baseSeconde(modele, "barre") : barreUnite();
  }

  function modeleChoisi() {
    var radio = $("input[data-al-lot-modele]:checked", pdp);
    return radio ? radio.value : null;
  }

  function donnees(id) {
    var noeud = pdp.querySelector('[data-al-lot-famille="' + id + '"]');
    if (!noeud) return null;
    try { return JSON.parse(noeud.textContent); } catch (e) { return null; }
  }

  /* `champ` vaut "prix" ou "barre" : même recherche, deux lectures. */
  function baseSeconde(id, champ) {
    var fiche = donnees(id);
    if (!fiche) return champ === "barre" ? barreUnite() : prixUnite();

    var select = $("[data-al-lot-variante]", pdp);
    if (select && select.value) {
      for (var i = 0; i < fiche.variantes.length; i++) {
        if (String(fiche.variantes[i].id) === String(select.value)) return fiche.variantes[i][champ] || 0;
      }
    }
    return fiche[champ] || 0;
  }

  function remplirTailles() {
    var select = $("[data-al-lot-variante]", pdp);
    if (!select) return;
    var d = donnees(modeleChoisi());
    select.innerHTML = "";
    if (!d) return;

    d.variantes.forEach(function (v) {
      var o = document.createElement("option");
      o.value = v.id;
      o.textContent = v.titre + (v.dispo ? "" : " — sold out");
      o.disabled = !v.dispo;
      select.appendChild(o);
    });

    /* On propose d'emblée la même pointure que la première paire. */
    var radio = varianteChoisie();
    if (radio) {
      var voulue = radio.value;
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].textContent.indexOf(voulue) === 0 && !select.options[i].disabled) {
          select.selectedIndex = i;
          break;
        }
      }
    }
  }

  /* Un prix barré n'a de sens que s'il dépasse le prix payé ; sinon on le
     masque plutôt que d'afficher une référence qui ne dit rien. */
  function poser(selecteur, montant, reference) {
    var el = $(selecteur, pdp);
    if (!el) return;
    if (reference > montant) {
      el.textContent = argent(reference);
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function majLot() {
    if (!lot) return;

    var unite = prixUnite();
    var barre = barreUnite();
    var seconde = prixSeconde();
    var barre2 = barreSeconde();

    var p1 = $("[data-al-palier-prix-1]", pdp);
    var p2 = $("[data-al-palier-prix-2]", pdp);
    var detail = $("[data-al-lot-seconde]", pdp);

    if (p1) p1.textContent = argent(unite);
    if (p2) p2.textContent = argent(unite + seconde);
    if (detail) detail.textContent = argent(seconde);

    poser("[data-al-palier-barre-1]", unite, barre);
    poser("[data-al-palier-barre-2]", unite + seconde, barre + barre2);
    poser("[data-al-lot-seconde-barre]", seconde, barre2);
  }

  function initLot() {
    if (!lot) return;

    $$("[data-al-palier]", pdp).forEach(function (radio) {
      radio.addEventListener("change", function () {
        lotPalier = Number(radio.value);
        $$(".al-lot__palier", pdp).forEach(function (l) { l.classList.remove("is-active"); });
        radio.closest(".al-lot__palier").classList.add("is-active");

        var corps = $("[data-al-lot-corps]", pdp);
        if (corps) corps.hidden = lotPalier !== 2;
        if (lotPalier === 2) remplirTailles();
        majLot();
      });
    });

    $$("[data-al-lot-modele]", pdp).forEach(function (radio) {
      radio.addEventListener("change", function () {
        remplirTailles();
        majLot();
      });
    });

    var select = $("[data-al-lot-variante]", pdp);
    if (select) select.addEventListener("change", majLot);

    remplirTailles();
    majLot();
  }

  /* ------------------------------------------------------ ajout panier --- */

  function lignes() {
    var id = Number(champId.value);
    /* Un identifiant vide ou non numérique partait tel quel et Shopify
       renvoyait un refus sec. On s'arrête avant, avec un message clair. */
    if (!id || !isFinite(id)) throw new Error("Please choose a size.");

    var principale = { id: id, quantity: 1 };
    if (lotPalier !== 2) return [principale];

    var select = $("[data-al-lot-variante]", pdp);
    if (!select || !select.value) return [principale];

    var seconde = Number(select.value);
    if (!seconde || !isFinite(seconde)) return [principale];
    /* Même pointure du même modèle : une ligne de deux, pas deux lignes. */
    if (seconde === principale.id) return [{ id: principale.id, quantity: 2 }];
    return [principale, { id: seconde, quantity: 1 }];
  }

  function initAjout() {
    var forme = $("[data-al-form]", pdp);
    var erreur = $("[data-al-erreur]", pdp);
    if (!forme) return;

    var enCours = false;

    forme.addEventListener("submit", function (e) {
      e.preventDefault();
      /* Deux appuis rapprochés envoyaient deux requêtes ; la seconde partait
         pendant que la première écrivait le panier. */
      if (enCours) return;

      var charge;
      try {
        charge = lignes();
      } catch (err) {
        if (erreur) { erreur.textContent = err.message; erreur.classList.remove("hidden"); }
        return;
      }

      enCours = true;
      bouton.disabled = true;
      if (boutonTexte) boutonTexte.textContent = "Adding…";
      if (erreur) erreur.classList.add("hidden");

      fetch(window.alRoutes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: charge })
      })
        .then(function (r) {
          return r.text().then(function (t) {
            var d = {};
            try { d = JSON.parse(t); } catch (e) {}
            return { ok: r.ok, statut: r.status, d: d };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            /* Le code HTTP est repris dans le message : sans lui, un refus de
               Shopify et une coupure réseau se ressemblent trop pour qu'on
               puisse les distinguer sur un signalement. */
            var m = res.d.description || res.d.message || "Could not add to cart.";
            throw new Error(m + " (" + res.statut + ")");
          }
          if (window.alRafraichirPanier) return window.alRafraichirPanier(true);
        })
        .catch(function (err) {
          if (erreur) { erreur.textContent = err.message; erreur.classList.remove("hidden"); }
        })
        .then(function () {
          enCours = false;
          bouton.disabled = false;
          if (boutonTexte) boutonTexte.textContent = "Add to cart";
        });
    });
  }

  initGalerie();
  initPointures();
  initLot();
  initAjout();
})();
